import React, { useState } from 'react'
import Progress from '../Progress'
import { PrimaryQuizButton, BackQuizButton } from '../Buttons'
import { useQuiz } from '../QuizProvider'
import { cn } from '../../../lib/utils'
import { useIsMobile } from '~/hooks/useMediaQuery'
import { useTranslation } from '~/hooks/useTranslation'

const Results = ({ className, children, isScrollable }) => {
  const { t } = useTranslation('QuizResults.Results')
  const { retakeQuiz } = useQuiz()
  const [disabledButton, setDisabledButton] = useState(false)
  const isMobile = useIsMobile()

  const handleNextClick = () => {
    setDisabledButton(true)
    const path = window.location.pathname.split('/')[1]
    const newUrl = `/${path}/resources`
    window.location.replace(newUrl)
  }

  const outerDivClassName = isScrollable
    ? cn('container mt-6 flex min-h-screen flex-col', className)
    : cn('container mt-6 flex flex-col', className)

  const innerDiv = isScrollable ? (
    <div className="my-6 flex flex-grow flex-col overflow-y-auto">
      {children}
    </div>
  ) : (
    <div className="mb-4 flex-grow">{children}</div>
  )

  return (
    <div className={outerDivClassName}>
      <Progress completed />
      {innerDiv}
      <div
        className={
          isMobile
            ? 'mb-2 mt-auto flex flex-col gap-4 self-center sm:gap-6 md:flex-row'
            : 'mb-2 mt-auto flex flex-col gap-4 self-end sm:gap-6 md:flex-row'
        }
      >
        <BackQuizButton onClick={retakeQuiz}>{t('retake_quiz')}</BackQuizButton>
        <div className="flex flex-col items-center gap-2">
          <PrimaryQuizButton
            onClick={handleNextClick}
            disabled={disabledButton}
            className="!w-auto"
          >
            {t('back_to_resource_center')}
          </PrimaryQuizButton>
        </div>
      </div>
    </div>
  )
}

export default Results

export const LinkifiedCopy = ({ copy, link }) => {
  const copySplit = copy.split('[link]')
  const { linkPath, linkText } = link
  const copy1 = copySplit[0]
  const copy2 = copySplit[1]
  return (
    <p>
      {copy1}
      {copy2 && (
        <a
          className="!underline"
          href={linkPath}
          target="_blank"
          rel="noopener noreferrer"
        >
          {linkText}
        </a>
      )}
      {copy2}
    </p>
  )
}
